export const debug = (message: unknown, ...rest: Array<unknown>): void => {
    if (process.env.NEXT_PUBLIC_DEPLOY_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.log(message, ...rest);
    }
};
